import { render } from "./FeaturedVouchersPage.vue?vue&type=template&id=67947c7a&scoped=true"
import script from "./FeaturedVouchersPage.vue?vue&type=script&lang=js"
export * from "./FeaturedVouchersPage.vue?vue&type=script&lang=js"

import "./FeaturedVouchersPage.vue?vue&type=style&index=0&id=67947c7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67947c7a"]])

export default __exports__